import { isDate, isString } from 'lodash';
import moment, { Moment } from 'moment';
import { MetadataType } from '../metadata/MetadataType';
import { ContextualValue } from './ContextualValue';

/**
 * Ritorna la data come Moment.
 * Se la data non esiste, ritorna undefined.
 */
function formatDate(date: Date | string | undefined): Moment | undefined {
  if (!date) return undefined;
  // In caso di input stringa
  if (isString(date)) {
    return moment.tz(date, [moment.ISO_8601, 'YYYY-MM-DD'], 'Europe/Rome');
  }

  // Per le date il parsing non serve
  return moment.tz(date, 'Europe/Rome');
}

/* Valori contestuali da SIAP */
export const SiapContextualValues = () => [
  ContextualValue.create({
    type: 'siapName',
    label: 'SIAP: Nome',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.name
  }),
  ContextualValue.create({
    type: 'siapSurname',
    label: 'SIAP: Cognome',
    requiresAuth: true,

    disableIfEmpty: true,
    fromRequest: request => request.siap?.surname
  }),
  ContextualValue.create({
    type: 'siapBirthdate',
    label: 'SIAP: Data di Nascita',
    datatype: MetadataType.Date,
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => formatDate(request.siap?.birthdate)
  }),
  ContextualValue.create({
    type: 'siapBirthMunicipality',
    label: 'SIAP: Comune di Nascita',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.birthMunicipality
  }),
  ContextualValue.create({
    type: 'siapBirthProvince',
    label: 'SIAP: Provincia di Nascita',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.birthProvince
  }),
  ContextualValue.create({
    type: 'siapBirthNation',
    label: 'SIAP: Stato di Nascita',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.birthNation
  }),
  ContextualValue.create({
    type: 'siapFiscalId',
    label: 'SIAP: Codice Fiscale',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.fiscalId
  }),
  ContextualValue.create({
    type: 'siapGender',
    label: 'SIAP: Sesso',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.gender
  }),
  ContextualValue.create({
    type: 'siapState',
    label: 'SIAP: Stato Servizio',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.state
  }),
  // ASSUNZIONE
  ContextualValue.create({
    type: 'siapHiringType',
    label: 'SIAP Assunzione: Tipo Rapporto',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.hiring.type
  }),
  ContextualValue.create({
    type: 'siapHiringFromDate',
    label: 'SIAP Assunzione: Data Inizio',
    datatype: MetadataType.Date,
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => formatDate(request.siap?.hiring.fromDate)
  }),
  ContextualValue.create({
    type: 'siapHiringToDate',
    label: 'SIAP Assunzione: Data Fine',
    datatype: MetadataType.Date,
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => formatDate(request.siap?.hiring.toDate)
  }),
  ContextualValue.create({
    type: 'siapHiringReason',
    label: 'SIAP Assunzione: Motivo',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.hiring.reason
  }),
  ContextualValue.create({
    type: 'siapHiringSpecific',
    label: 'SIAP Assuzione: Specifica',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.hiring.specific
  }),
  // PROFILO
  ContextualValue.create({
    type: 'siapProfileFromDate',
    label: 'SIAP Profilo: Data Inizio',
    datatype: MetadataType.Date,
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => formatDate(request.siap?.profile.fromDate)
  }),
  ContextualValue.create({
    type: 'siapProfileEconomicDate',
    label: 'SIAP Profilo: Data Economica',
    datatype: MetadataType.Date,
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => formatDate(request.siap?.profile.economicDate)
  }),
  ContextualValue.create({
    type: 'siapProfileToDate',
    label: 'SIAP Profilo: Data Fine',
    datatype: MetadataType.Date,
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => formatDate(request.siap?.profile.toDate)
  }),
  ContextualValue.create({
    type: 'siapProfileDenomination',
    label: 'SIAP Profilo: Denominazione',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.profile.denomination
  }),
  ContextualValue.create({
    type: 'siapProfileArea',
    label: 'SIAP Profilo: Area',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.profile.area
  }),
  ContextualValue.create({
    type: 'siapProfileFascia',
    label: 'SIAP Profilo: Fascia',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.profile.fascia
  }),
  ContextualValue.create({
    type: 'siapProfileSpecific',
    label: 'SIAP Profilo: Specifica',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.profile.specific
  }),
  // ASSEGNAZIONE
  ContextualValue.create({
    type: 'siapAssignmentFromDate',
    label: 'SIAP Assegnazione: Data Inizio',
    datatype: MetadataType.Date,
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => formatDate(request.siap?.assignment.fromDate)
  }),
  ContextualValue.create({
    type: 'siapAssignmentServiceStartDate',
    label: 'SIAP Assegnazione: Data Presa Servizio',
    datatype: MetadataType.Date,
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request =>
      formatDate(request.siap?.assignment.serviceStartDate)
  }),
  ContextualValue.create({
    type: 'siapAssignmentToDate',
    label: 'SIAP Assegnazione: Data Fine',
    datatype: MetadataType.Date,
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => formatDate(request.siap?.assignment.toDate)
  }),
  ContextualValue.create({
    type: 'siapAssignmentAooCode',
    label: 'SIAP Assegnazione: Codice AOO',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.assignment.aooCode
  }),
  ContextualValue.create({
    type: 'siapAssignmentAooName',
    label: 'SIAP Assegnazione: Denominazione Istituto',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.assignment.aooName
  }),
  ContextualValue.create({
    type: 'siapAssignmentAooHeadOffice',
    label: 'SIAP Assegnazione: Sede Servizio Istituto ',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.assignment.aooHeadOffice
  }),
  ContextualValue.create({
    type: 'siapAssignmentSpecific',
    label: 'SIAP Assegnazione: Specifica',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.assignment.specific
  }),
  ContextualValue.create({
    type: 'siapAssignmentMunicipality',
    label: 'SIAP Assegnazione: Comune',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.assignment.municipality
  }),
  ContextualValue.create({
    type: 'siapAssignmentProvince',
    label: 'SIAP Assegnazione: Provincia',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.assignment.province
  }),
  ContextualValue.create({
    type: 'siapAssignmentRegion',
    label: 'SIAP Assegnazione: Regione',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.assignment.region
  }),
  // INCARICO DIRIGENZIALE
  ContextualValue.create({
    type: 'siapManagerialFromDate',
    label: 'SIAP Incarico Dirigenziale: Data Inizio',
    datatype: MetadataType.Date,
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request =>
      formatDate(request.siap?.managerialPosition.fromDate)
  }),
  ContextualValue.create({
    type: 'siapManagerialServiceStartDate',
    label: 'SIAP Incarico Dirigenziale: Data Presa Servizio',
    datatype: MetadataType.Date,
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request =>
      formatDate(request.siap?.managerialPosition.serviceStartDate)
  }),
  ContextualValue.create({
    type: 'siapManagerialToDate',
    label: 'SIAP Incarico Dirigenziale: Data Fine',
    datatype: MetadataType.Date,
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => formatDate(request.siap?.managerialPosition.toDate)
  }),
  ContextualValue.create({
    type: 'siapManagerialAooCode',
    label: 'SIAP Incarico Dirigenziale: Codice AOO',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.managerialPosition.aooCode
  }),
  ContextualValue.create({
    type: 'siapManagerialAooName',
    label: 'SIAP Incarico Dirigenziale: Denominazione Istituto',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.managerialPosition.aooName
  }),
  ContextualValue.create({
    type: 'siapManagerialAooHeadOffice',
    label: 'SIAP Incarico Dirigenziale: Sede Servizio Istituto',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.managerialPosition.aooHeadOffice
  }),
  ContextualValue.create({
    type: 'siapManagerialSpecific',
    label: 'SIAP Incarico Dirigenziale: Specifica',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.managerialPosition.specific
  }),
  ContextualValue.create({
    type: 'siapManagerialMunicipality',
    label: 'SIAP Incarico Dirigenziale: Comune',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.managerialPosition.municipality
  }),
  ContextualValue.create({
    type: 'siapManagerialProvince',
    label: 'SIAP Incarico Dirigenziale: Provincia',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.managerialPosition.province
  }),
  ContextualValue.create({
    type: 'siapManagerialRegion',
    label: 'SIAP Incarico Dirigenziale: Regione',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.managerialPosition.region
  }),
  // DISTACCO
  ContextualValue.create({
    type: 'siapDetachmentFromDate',
    label: 'SIAP Distacco: Data Inizio',
    datatype: MetadataType.Date,
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => formatDate(request.siap?.detachment.fromDate)
  }),
  ContextualValue.create({
    type: 'siapDetachmentServiceStartDate',
    label: 'SIAP Distacco: Data Presa Servizio ',
    datatype: MetadataType.Date,
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request =>
      formatDate(request.siap?.detachment.serviceStartDate)
  }),
  ContextualValue.create({
    type: 'siapDetachmentToDate',
    label: 'SIAP Distacco: Data Fine',
    datatype: MetadataType.Date,
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => formatDate(request.siap?.detachment.toDate)
  }),
  ContextualValue.create({
    type: 'siapDetachmentAooCode',
    label: 'SIAP Distacco: Codice AOO',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.detachment.aooCode
  }),
  ContextualValue.create({
    type: 'siapDetachmentAooName',
    label: 'SIAP Distacco: Denominazione Istituto',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.detachment.aooName
  }),
  ContextualValue.create({
    type: 'siapDetachmentAooHeadOffice',
    label: 'SIAP Distacco: Sede Servizio Istituto',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.detachment.aooHeadOffice
  }),
  ContextualValue.create({
    type: 'siapDetachmentMunicipality',
    label: 'SIAP Distacco: Comune',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.detachment.municipality
  }),
  ContextualValue.create({
    type: 'siapDetachmentProvince',
    label: 'SIAP Distacco: Provincia',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.detachment.province
  }),
  ContextualValue.create({
    type: 'siapDetachmentRegion',
    label: 'SIAP Distacco: Regione',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.detachment.region
  }),
  // COMMAND OUT
  ContextualValue.create({
    type: 'siapCommandOutFromDate',
    label: 'SIAP Comando OUT: Data Inizio',
    datatype: MetadataType.Date,
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => formatDate(request.siap?.commandOut.fromDate)
  }),
  ContextualValue.create({
    type: 'siapCommandOutToDate',
    label: 'SIAP Comando OUT: Data Fine',
    datatype: MetadataType.Date,
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => formatDate(request.siap?.commandOut.toDate)
  }),
  ContextualValue.create({
    type: 'siapCommandOutHeadOffice',
    label: 'SIAP Comando OUT: Sede',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.commandOut.headOffice
  }),
  // CESSAZIONE
  ContextualValue.create({
    type: 'siapTerminationDate',
    label: 'SIAP: Data Cessazione',
    datatype: MetadataType.Date,
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => formatDate(request.siap?.termination.date)
  }),
  ContextualValue.create({
    type: 'siapTerminationDescription',
    label: 'SIAP: Motivo Cessazione',
    requiresAuth: true,
    disableIfEmpty: true,
    fromRequest: request => request.siap?.termination.description
  })
];
